import constants, { DISPLAY_MODES } from '../constants/common';
import getIsOpen from './is-open';
import getDisplayMode from './display-mode';

// The width the docked chat takes away from the main application. Anything but
// an open sidebar overlays the editor instead of docking, so it costs 0.
const getPanelWidth = (rootState) => {
  if (!getIsOpen(rootState)) return 0;
  if (getDisplayMode(rootState) !== DISPLAY_MODES.RIGHT) return 0;

  return constants.PANEL_WIDTH;
};

export default getPanelWidth;
